/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FavoriteHotel } from './FavoriteHotel';
import {
    FavoriteHotelFromJSON,
    FavoriteHotelFromJSONTyped,
    FavoriteHotelToJSON,
    FavoriteHotelToJSONTyped,
} from './FavoriteHotel';

/**
 * 
 * @export
 * @interface FavoriteHotelCollection
 */
export interface FavoriteHotelCollection {
    /**
     * 
     * @type {Array<FavoriteHotel>}
     * @memberof FavoriteHotelCollection
     */
    items: Array<FavoriteHotel>;
    /**
     * 
     * @type {string}
     * @memberof FavoriteHotelCollection
     */
    nextCursor: string | null;
}

/**
 * Check if a given object implements the FavoriteHotelCollection interface.
 */
export function instanceOfFavoriteHotelCollection(value: object): value is FavoriteHotelCollection {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('nextCursor' in value) || value['nextCursor'] === undefined) return false;
    return true;
}

export function FavoriteHotelCollectionFromJSON(json: any): FavoriteHotelCollection {
    return FavoriteHotelCollectionFromJSONTyped(json, false);
}

export function FavoriteHotelCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FavoriteHotelCollection {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(FavoriteHotelFromJSON)),
        'nextCursor': json['next_cursor'],
    };
}

export function FavoriteHotelCollectionToJSON(json: any): FavoriteHotelCollection {
    return FavoriteHotelCollectionToJSONTyped(json, false);
}

export function FavoriteHotelCollectionToJSONTyped(value?: FavoriteHotelCollection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(FavoriteHotelToJSON)),
        'next_cursor': value['nextCursor'],
    };
}

